import React, { useEffect, useRef, useState } from 'react';
import genStyles from '../generale.module.css';

// Champ de saisie inline du nom de collection (création / édition directement dans le tableau)
// Entrée ou perte du focus => onSubmit(valeur), Échap => onCancel()
export default function InlineNameInput({ initialValue = '', placeholder = 'Ma collection', onSubmit, onCancel }) {
    const [value, setValue] = useState(initialValue);
    const inputRef = useRef(null);
    const doneRef = useRef(false);

    useEffect(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
    }, []);

    const submit = () => {
        if (doneRef.current) return;
        doneRef.current = true;
        onSubmit(value.trim());
    };

    const cancel = () => {
        if (doneRef.current) return;
        doneRef.current = true;
        onCancel();
    };

    return (
        <input
            ref={inputRef}
            className={`${genStyles.inputtCol} ${genStyles.inlineNameInput}`}
            type="text"
            value={value}
            placeholder={placeholder}
            maxLength={50}
            onChange={(e) => setValue(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    submit();
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    cancel();
                }
            }}
            onBlur={submit}
        />
    );
}
